var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLelyMilkDropList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 500a250 250 0 1 0-1-500 250 250 0 0 0 1 500Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m254 330-2 1h-5l-2-1-30-37-1-2v-2l2-2h13v-7c0-2 1-2 3-2h4c1 0 3 0 3 2v11l-1 3-4 1h-5l21 24 19-24h-5l-3-1-1-3v-37c0-2 1-4 3-4h3c2 0 3 2 3 4v33h14l1 2 1 2-1 2Zm-25-68c0-1 1-2 3-2h4l3 2v4l-3 2h-4c-2 0-3-1-3-2Zm-56-157c0-27 35-49 78-49 42 0 78 22 78 49 0 26-36 48-78 48-43 0-78-22-78-48Zm117 1 8-33-10 4-4 21-8-16-7 3 11 23v21l10 5Zm-16 13-10-5V87l-9 3v29l19 8Zm-28-28-13-6v39l13-6v-7l-6 2v-5l6-1v-4l-6-1v-6l6 2Zm-18 28-12 4V78l-10-4v62l22-9Zm98 171v136c0 14-12 26-26 25H198c-14 0-25-11-25-25V290c0-11 3-23 10-32l24-36v-5c-5 0-9-4-9-8v-34c0-5 4-8 9-8h84c5 0 9 3 9 8v34c0 4-4 8-9 8v5l24 36c7 10 11 21 11 32Zm-111-90h68v-17h-68Zm93 88c0-7-3-15-7-21l-25-36-1-6v-8h-52v8l-1 6-25 36c-5 7-7 16-7 23v62l3 1c19 4 38 2 54-6 19-10 40-13 61-9Z",
    fill: "#CF1322"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLelyMilkDropList);
export default __webpack_public_path__ + "static/media/lely-milk-drop-list.af06c4dd.svg";
export { ForwardRef as ReactComponent };